import styled from 'styled-components';
import {Space} from 'antd';

const StyledImageLabelOption = styled(Space)`
  .ant-space-item {
    display: flex;
  }
  
  svg {
    height: 24px;
    width: 24px;
    path {
      fill: ${props => props.theme.colors.neutral_6};
    }
  }
`;

export {
  StyledImageLabelOption,
};
